import { apiClient } from './apiClient';

const callerService = {
  // Teilnehmer abhaken
  checkParticipant: async (groupId, participantId) => {
    try {
      const data = await apiClient.post(`/caller/check/${groupId}/${participantId}`, null);
      return { success: true, data };
    } catch (error) {
      console.error('Error checking participant:', error);
      return { success: false, error: error.message };
    }
  },

  // Häkchen entfernen
  uncheckParticipant: async (groupId, participantId) => {
    try {
      const data = await apiClient.post(`/caller/uncheck/${groupId}/${participantId}`, null);
      return { success: true, data };
    } catch (error) {
      console.error('Error unchecking participant:', error);
      return { success: false, error: error.message };
    }
  },

  // Checkliste für Gruppe abrufen
  getChecklist: async (groupId) => {
    try {
      const data = await apiClient.get(`/caller/checklist/${groupId}`);
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching checklist:', error);
      return { success: false, error: error.message };
    }
  }
};

export default callerService;

